exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".HvQkXgCjOh6rxRVNfR_yN{color:\"[theme:neutralPrimary, default:#333333]\";font-size:12px;white-space:nowrap}html[dir] .HvQkXgCjOh6rxRVNfR_yN{padding:10px 0 4px 0;text-align:center}", ""]);
// Exports
exports.locals = {
	"timeZonePanel": "HvQkXgCjOh6rxRVNfR_yN"
};